// Форматы «Загрузки кухни». Бэкенд отдаёт числа без округления (заказы бывают дробными —
// заказ, разделённый между группами; среднее за день — дробное), округляем только здесь.
import { KITCHEN_OTHER_COLOR, KITCHEN_PLACE_COLORS, hexToRgb } from '../../styles/tokens';

export const round = (value) => Math.round(Number(value) || 0);

export function plural(value, [one, few, many]) {
  const n = Math.abs(round(value)) % 100;
  const last = n % 10;
  if (n > 10 && n < 20) return many;
  if (last === 1) return one;
  if (last >= 2 && last <= 4) return few;
  return many;
}

export const formatInt = (value) => round(value).toLocaleString('ru-RU');

export const formatMoney = (value) => `${formatInt(value)} ₽`;

// Коротко для подписи над столбиком: «47 тыс ₽», «980 ₽»
export function formatMoneyShort(value) {
  const n = Number(value) || 0;
  if (Math.abs(n) < 1000) return `${round(n)} ₽`;
  const thousands = n / 1000;
  const text = thousands >= 100 ? String(Math.round(thousands)) : thousands.toFixed(1).replace('.', ',').replace(',0', '');
  return `${text} тыс ₽`;
}

export const itemsText = (value) => `${formatInt(value)} ${plural(value, ['позиция', 'позиции', 'позиций'])}`;
export const ordersText = (value) => `${formatInt(value)} ${plural(value, ['заказ', 'заказа', 'заказов'])}`;

export const placeColor = (place) =>
  place.color_index === null || place.color_index === undefined
    ? KITCHEN_OTHER_COLOR
    : KITCHEN_PLACE_COLORS[place.color_index % KITCHEN_PLACE_COLORS.length];

// «2 ч 44 мин», «35 мин»
export function formatDuration(minutes) {
  const total = Math.max(0, round(minutes));
  const hours = Math.floor(total / 60);
  const rest = total % 60;
  return hours ? `${hours} ч ${rest} мин` : `${rest} мин`;
}

// «2026-10-22 18:56:22» (местное время ресторана) → «18:56»
export const openedTime = (opened) => (typeof opened === 'string' ? opened.slice(11, 16) : '');

// Заголовок открытого заказа: доставка — «Доставка Яндекс Еда №43», в зале — «Стол 12» (lower — внутри фразы)
export function orderTitle(order, { lower = false } = {}) {
  if (!order) return '';
  if (order.kind === 'delivery') return `${order.order_type || 'Доставка'}${order.number != null ? ` №${order.number}` : ''}`;
  const title = order.table != null ? `Стол ${order.table}` : order.table_name || 'Без стола';
  return lower && order.table != null ? title.toLowerCase() : lower && !order.table_name ? 'без стола' : title;
}

// Пометка «данные на HH:MM, iikoCloud не отвечает» (последний удачный ответ) — и у открытых, и у закрытых
export const STALE_COLOR = '#f0a43a';

// Время обновления данных (UTC с «Z») → «21:39» по часам устройства
export const clockTime = (iso) =>
  iso ? new Date(iso).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }) : '';

// Цвет места живой части — тот же, что у места в отчёте по закрытым заказам; иначе «Прочее»
export function placeColorByName(places, name) {
  const place = (places || []).find((p) => p.name === name);
  return placeColor(place || { color_index: null });
}

// Открыт дольше — время подсвечивается
export const LONG_OPEN_MINUTES = 120;

// Нейтральная штриховка (открытые без цеха, чип «Открыто»): тихие полосы 45°, шаг ~6px, без рамки
export const HATCH_SX = {
  background: 'repeating-linear-gradient(45deg, rgba(255,255,255,0.22) 0 3px, rgba(255,255,255,0.04) 3px 6px)',
};

// Открытые позиции цеха: полосы цвета цеха (0.55) на фоне того же цвета (0.15) — цвет = цех, штриховка = статус
export function placeHatchSx(color) {
  const rgb = hexToRgb(color);
  return { background: `repeating-linear-gradient(45deg, rgba(${rgb},0.55) 0 3px, rgba(${rgb},0.15) 3px 6px)` };
}

// Сколько в стопе: до 2 суток — часами и минутами («25 мин», «41 ч 12 мин»), дольше — днями («193 дня»)
export function formatAge(minutes) {
  const total = Math.max(0, round(minutes));
  if (total <= 2 * 1440) return formatDuration(total);
  const days = Math.floor(total / 1440);
  return `${days} ${plural(days, ['день', 'дня', 'дней'])}`;
}

// С какого момента (местное время ресторана, «2026-10-22 09:57:24») относительно местного «сейчас»:
// «с 09:57» — сегодня, «с 09:57 вчера», иначе «с 21.10 09:57»
export function formatSince(added, localNow) {
  if (typeof added !== 'string') return '';
  const time = added.slice(11, 16);
  const day = added.slice(0, 10);
  const today = typeof localNow === 'string' ? localNow.slice(0, 10) : new Date().toISOString().slice(0, 10);
  if (day === today) return `с ${time}`;
  const yesterday = new Date(`${today}T12:00:00Z`);
  yesterday.setUTCDate(yesterday.getUTCDate() - 1);
  if (day === yesterday.toISOString().slice(0, 10)) return `с ${time} вчера`;
  return `с ${day.slice(8, 10)}.${day.slice(5, 7)} ${time}`;
}
